import { SparklesIcon } from "lucide-react";
import * as React from "react";
import { Tooltip } from "@/components/ui/tooltip";
import clsx from "clsx";
import { SearchMode } from "./types";

interface Props {
  searchMode: SearchMode;
  onModeChange: (mode: SearchMode) => void;
}

const tooltipContent = {
  standard: (
    <div className="text-sm">
      <p className="mb-1 font-semibold">Standard Search</p>
      <p className="text-gray-300">Traditional keyword-based search by file and folder names</p>
    </div>
  ),
  ai: (
    <div className="text-sm">
      <p className="mb-1 font-semibold">AI Search</p>
      <p className="text-gray-300">
        Use natural language to find documents. Ask questions like "show me reports from last month" or "budget files
        for 2025"
      </p>
    </div>
  ),
};

export const SearchModeToggle: React.FC<Props> = ({ searchMode, onModeChange }) => {
  const getButtonClasses = (mode: SearchMode) =>
    clsx("flex h-8 items-center rounded-md px-3 text-sm font-medium", {
      "bg-white text-midnight-blue shadow-sm": searchMode === mode,
      "text-gray-500 hover:text-midnight-blue": searchMode !== mode,
    });

  return (
    <div role="group" aria-label="Search mode" className="flex rounded-lg bg-gray-100 p-1">
      <Tooltip text={tooltipContent.standard} className="max-w-xs bg-gray-900 text-white" side="top">
        <button
          type="button"
          aria-pressed={searchMode === "standard"}
          onClick={() => onModeChange("standard")}
          className={getButtonClasses("standard")}
        >
          Standard
        </button>
      </Tooltip>

      <Tooltip text={tooltipContent.ai} className="max-w-xs bg-gray-900 text-white" side="top">
        <button
          type="button"
          aria-pressed={searchMode === "ai"}
          onClick={() => onModeChange("ai")}
          className={clsx(getButtonClasses("ai"), "gap-1.5")}
        >
          <SparklesIcon className="h-4 w-4" />
          AI Search
        </button>
      </Tooltip>
    </div>
  );
};
